import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {ApiService} from '../../../@core/service/api.service';
import {Observable, Subscription} from 'rxjs';
import {BusinessModel, ContactModel} from '../../../@models';
import {CompleterData, CompleterItem, CompleterService} from 'ng2-completer';

@Component({
  selector: 'ngx-form-customer',
  templateUrl: './form-customer.component.html',
  styleUrls: ['./form-customer.component.scss'],
})
export class FormCustomerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() title: string;
  @Input() value: BusinessModel;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() enabled: boolean = true;
  @Input() rsm: string = null;

  businessName: string;

  customerService: CompleterData;

  constructor(private api: ApiService, private completerService: CompleterService) {

  }

  ngOnInit() {
    if (this.rsm) {
      this.api.reloadBusiness({active: true}).subscribe(x => {
        this.customerService = this.completerService.local(
          x.filter(y => ((y.manager as ContactModel) || {_id: null})._id === this.rsm),
          'name', 'name');
      })
    } else {
      this.customerService = this.completerService.local(this.api.reloadBusiness({active: true}), 'name', 'name');

    }

    if (this.value != null) {
      this.businessName = this.value.name;
    } else {
      this.businessName = null;
    }
  }

  ngOnDestroy(): void {
    // this.customerSubscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value != null && changes.value.currentValue != null)
      this.businessName = changes.value.currentValue.name;
  }
  select(item: CompleterItem): void {
    if (item != null)
      this.valueChange.emit(item.originalObject);
  }
}
